// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'snow';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M9 .563v5.625m2.813-4.5L9 3.938l-2.813-2.25M1.693 4.781l4.871 2.813M4.073 2.908l.542 3.56L1.261 7.78m.432 5.439 4.871-2.813M1.26 10.22l3.355 1.311-.542 3.561M9 17.438v-5.625m-2.812 4.5L9 14.063l2.813 2.25m4.494-3.094-4.871-2.813m2.491 4.686-.542-3.56 3.354-1.312m-.432-5.439-4.871 2.813m5.304.186-3.355-1.311.542-3.561M9 6.188 6.564 7.593v2.812L9 11.812l2.436-1.406V7.594z'
  />
);

export const viewBox = '0 0 18 18';
